import { Helpers } from '../../helpers';
import { ILeaseStatus } from '../../interfaces/ilease-status';
import { Lease } from '../lease';

export class LeaseStatusBase {
  LeaseStatusId: number;
  Description: string;
  Abbreviation: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Leases_LeaseStatus?: Array<Lease> | null;

  constructor(item?: ILeaseStatus) {
    if (item) {

      this.LeaseStatusId = item.LeaseStatusId;
      this.Description = item.Description;
      this.Abbreviation = item.Abbreviation;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Leases_LeaseStatus = Helpers.createClassArray(Lease, item.Leases_LeaseStatus);
    }
  }
}